/**
 *
 * universal code for close current .modal window
 */
$(document).on('click', ".js-modal-close", function(e){
  var $this = $(this);
  $this.closest('.modal').removeAttr('style');
});